<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :currencyUnit="currencyUnit"
      :salesCurrencyUnit="salesCurrencyUnit"
      :disabledHsCode="disabledHsCode"
      :disabled="disabled"
      :masterCategoryCode="masterCategoryCode"
      @reload="getData"
      @checkboxChange="onCheckboxChange"
      @change="(e) => $emit('change', e)"
    >
      <div class="d-flex align-items-center" slot="header">
        <div class="side-frame-success"></div>
        <div>
          <span style="font-size: 15px; color: #606266">
            {{ $l('INDEX.table_title_spec') || '规格信息' }}
          </span>
        </div>
        <el-divider
          direction="vertical"
          v-if="!disabledHsCode && !disabled"
        ></el-divider>
        <el-badge :value="checkedCount" v-if="!disabledHsCode && !disabled">
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="editHsCode"
            :disabled="!checkedCount"
          >
            {{ $l('INDEX.btn_edit_spec_customs') || '编辑规格报关信息' }}
          </b-button>
        </el-badge>
      </div>
    </page-main>

    <EditHscode
      :title="$l('INDEX.dialog_title_edit_spec_customs') || '编辑规格报关信息'"
      :visible.sync="editHscodeOptions.visible"
      :listGoodsSpec="editHscodeOptions.listGoodsSpec"
      :masterCategoryCode="masterCategoryCode"
      @confirm="setHscode"
    />
  </div>
</template>
<script>
import PageMain from './main'
import EditHscode from '../edit-hscode'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, EditHscode },
  mixins: [EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
    currencyUnit: { type: String, default: '' },
    salesCurrencyUnit: { type: String, default: '' },
    masterCategoryCode: { type: String, default: '' },
    disabledHsCode: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      editHscodeOptions: { visible: false, listGoodsSpec: [] },
      checkedRow: [],
      loading: false,
      tableData: [],
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.shipmentCode || !this.orderGoodsCode) return
      const params = {
        shipmentCode: this.shipmentCode,
        orderGoodsCode: this.orderGoodsCode,
      }
      this.loading = true
      this.$api
        .shipmentHscodeGoodsSpecListApi(params)
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    onCheckboxChange(e) {
      this.checkedRow = e
    },
    editHsCode() {
      if (!this.checkedCount) return
      this.editHscodeOptions = {
        visible: true,
        listGoodsSpec: this.checkedRow,
      }
    },
    setHscode(e) {
      this.$refs.main.setHscode(e)
      this.checkedRow = []
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    async validate() {
      return await this.$refs.main.validate()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  height: 20px;
  margin: 8px 0;
}

::v-deep .btn-sm,
.btn-group-sm > .btn {
  padding: 0.2rem 0.25rem;
  font-size: 0.8rem;
  line-height: 1.2rem;
  border-radius: 0.2rem;
}
</style>
